<div class="stick-top">
  <mat-toolbar>
    <mat-icon>sms</mat-icon> SMPP Server Ports
  </mat-toolbar>
  <div class="hbox lightly-padded button-bar">
    <button mat-raised-button class="primary" routerLink="/smppserver/smppServerPorts/0">
        <mat-icon>add</mat-icon>
        Create a new SMPP Server Port
      </button>
  </div>
</div>

<div class="padded">
  <table class="basicTable">
    <thead>
      <tr>
        <th>
          <div class="vbox">
            Name
            <input [(ngModel)]="filter.name">
          </div>
        </th>
        <th>
          <div class="vbox">
            Port
            <input [(ngModel)]="filter.port">
          </div>
        </th>
        <th>
          <div class="vbox">
            Server
            <micro-smppServer-select [(smppServerId)]="filter.server"></micro-smppServer-select>
          </div>
        </th>
        <th>
          <div class="vbox">
            Enabled
            <micro-yesNo-select [(yesNo)]="filter.enabled" yesOption="ENABLED" noOption="DISABLED"></micro-yesNo-select>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let element of dataSource.data">
        <td [ngClass]="element.error ? 'CRITICAL' : ''" [matTooltip]="element.error"><a routerLink="/smppserver/smppServerPorts/{{element.id}}">{{element.name}}</a></td>
        <td>{{element.port}}</td>
        <td><micro-smppServer-lookup [smppServerId]="element.servers"></micro-smppServer-lookup></td>
        <td>{{element.enabled ? 'ENABLED' : 'DISABLED'}}</td>
      </tr>
      <tr *ngIf="dataSource.data?.length === 0">
        <td colspan="100"><em>No results found</em></td>
      </tr>
    </tbody>
    <tfoot>
    <tr>
      <td colspan="100">
        <mat-paginator #paginator
                       (page)="reload()"
                       [pageSize]="10"
                       [pageSizeOptions]="[5, 10, 20]">
        </mat-paginator>
      </td>
    </tr>
    </tfoot>
  </table>
</div>
